import React from 'react';

const SvgMinus = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <path fill="#000" fillRule="nonzero" d="M2 6v2h10V6z" />
    </svg>
);

export default SvgMinus;
